module.exports = __webpack_public_path__ + "f2709456b9f005f02b01abbc4361d6db.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/head/Impressum.jpg
// module id = 477
// module chunks = 0